import { render, staticRenderFns } from "./lab-article.vue?vue&type=template&id=b698411a&"
import script from "./lab-article.vue?vue&type=script&lang=js&"
export * from "./lab-article.vue?vue&type=script&lang=js&"
import style0 from "./lab-article.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports